/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useTranslation } from 'react-i18next';

export default function usePrefixedTranslation(prefix: string) {
  const { t } = useTranslation();
  const prefixedT = (key: string): string => t<string>(`${prefix}${key}`);
  return prefixedT;
}
